var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3060_2557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.003 0.494873H11.997C5.3805 0.494873 0 5.87918 0 12.5C0 15.1261 0.846 17.5602 2.2845 19.5365L0.789 23.9964L5.4015 22.5213C7.299 23.7788 9.5625 24.5051 12.003 24.5051C18.6195 24.5051 24 19.1193 24 12.5C24 5.88068 18.6195 0.494873 12.003 0.494873Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9868 17.4474C18.6973 18.2653 17.5483 18.9436 16.6318 19.1417C16.0048 19.2752 15.1858 19.3818 12.4288 18.2383C8.9023 16.7767 6.6313 13.1916 6.4543 12.959C6.2848 12.7264 5.0293 11.0607 5.0293 9.33797C5.0293 7.61523 5.9038 6.77637 6.2563 6.41622C6.5458 6.12059 7.0243 5.98553 7.4833 5.98553C7.6318 5.98553 7.7653 5.99304 7.8853 5.99904C8.2378 6.01405 8.4148 6.03506 8.6473 6.59179C8.9368 7.28959 9.6418 9.01233 9.7258 9.18941C9.8113 9.36648 9.8968 9.60658 9.7768 9.83918C9.6643 10.0793 9.5653 10.1858 9.3883 10.3899C9.2113 10.594 9.0433 10.7501 8.8663 10.9692C8.7043 11.1597 8.5213 11.3638 8.7253 11.7165C8.9293 12.0616 9.6343 13.2126 10.6723 14.137C12.0118 15.33 13.0978 15.7112 13.4863 15.8733C13.7758 15.9933 14.1208 15.9648 14.3323 15.7397C14.6008 15.4501 14.9323 14.9699 15.2698 14.4972C15.5098 14.158 15.8128 14.116 16.1308 14.2361C16.4548 14.3486 18.1693 15.1965 18.5218 15.372C18.8743 15.5491 19.1068 15.6332 19.1923 15.7817C19.2763 15.9303 19.2763 16.6281 18.9868 17.4474Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3060_2557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.0103,
    fill: "white",
    transform: "translate(0 0.494873)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.da4b2aa283edb78756707b2090521d5b.svg";
export { ForwardRef as ReactComponent };